import fetch from 'services/request';
import { IRequestBooking, IRequestBookingV3 } from './types/api';
import { IUpdateAppointmentStatusPayload } from './types/confirm';

const getTimeSlot = (currentDate: string, staffId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/appointment/getAvailableTimeSlotBookOnline/',
    params: { currentDate, staffId },
  });
};

const getAppointmentDetail = (id: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/appointment/getAppointmentById/' + id,
  });
};

const getCustomerDetailByPhone = (phone: string) => {
  return fetch({
    method: 'get',
    // url: `api/v1/customer/signInByPhone/${phone}`,
    url: 'api/v1/customer/getAllCustomerAutoSearch',
    params: {
      keyWord: phone,
    }
  });
};

const getCustomerDetailById = (customerId: string) => {
  return fetch({
    method: 'get',
    url: `/api/v1/customer/detail/${customerId}`,
  });
};

const bookAppointment = (payload: IRequestBooking) => {
  return fetch({
    url: 'api/v1/appointment/v2/bookingAppointment',
    method: 'post',
    body: {
      type: 'FEEDBACK/DASHBOARD/ON_CREATE_APPOITMENT',
      payload
    },
  });
};

const bookAppointmentV3 = (payload: IRequestBookingV3) => {
  return fetch({
    url: '/api/v1/appointment/bookingV3',
    method: 'post',
    body: {
      payload
    },
  });
};

const depositBooking = (amount: number, appointment: IRequestBooking) => {
  return fetch({
    url: '/api/v1/appointment/deposit-booking',
    method: 'post',
    body: { amount, appointment }
  });
};
const depositBookingV2 = (amount: number, appointment: IRequestBookingV3) => {
  return fetch({
    url: '/api/v1/appointment/deposit-booking-v2',
    method: 'post',
    body: { amount, appointment }
  });
};

const transactionDetail = (id: string) => {
  return fetch({
    url: `/api/v1/appointment/transactionDetail/${id}`,
    method: 'post',
  });
};

const getAvailableTimeSlotByStore = (date: string) => {
  return fetch({
    url: 'api/v1/appointment/available-time-slot-store',
    params: { date, source:'ONLINE' },
  });
};

const updateAppointmentStatus = (payload: IUpdateAppointmentStatusPayload) => fetch({
    method: 'put',
    url: 'api/v1/appointment/update-status',
    body: payload
});


const aptApis = {
  getTimeSlot,
  getAppointmentDetail,
  getCustomerDetailByPhone,
  getCustomerDetailById,
  bookAppointment,
  bookAppointmentV3,
  depositBooking,
  depositBookingV2,
  transactionDetail,
  getAvailableTimeSlotByStore,
  updateAppointmentStatus
};

export default aptApis;
